/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");





/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/es6.object.to-string.js
 ** module id = 511
 ** module chunks = 0
 **/